export const contentCategoryOptions = [
  {
    value: 'NEWS',
    label: 'News'
  },
  {
    value: 'FAQ',
    label: 'FAQs'
  },
  {
    value: 'LINK',
    label: 'Link'
  },
  {
    value: 'TERMS',
    label: 'terms'
  },
  {
    value: 'PRIVACY',
    label: 'privacy'
  }
]

export const contentCategoryEnum = contentCategoryOptions.reduce(
  (prevous, current) => ({ ...prevous, [current.value]: current.value }),
  {}
)

export const primaryContentTypes = ['NEWS']
